import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Organization } from 'src/app/services/organization.model';
import { OrganizationService } from '../organization.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/base/base.component';
import { DatePipe } from '@angular/common';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateOrganizationDialogComponent } from '../create-organization-dialog/create-organization-dialog.component';
import { AuthService } from 'src/app/auth.service';
import { OrganizationsUsersComponent } from '../organizations-users/organizations-users.component';
import { UserDataService } from 'src/app/services/user-data-service';
import { OrganizationsSessiontimeoutComponent } from '../organizations-sessiontimeout/organizations-sessiontimeout.component';
import { DeactivateOrganizationDialogComponent } from '../deactivate-organization-dialog/deactivate-organization-dialog.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';


@Component({
    selector: 'app-organization-list-view',
    templateUrl: './organization-list-view.component.html',
    styleUrls: ['./organization-list-view.component.css'],
    standalone: false
})
export class OrganizationListViewComponent extends BaseComponent implements OnInit {
  organization = new MatTableDataSource<Organization>(); 
  hasError: boolean = false;
  role:Number=0;
  message :string='';
  selectedOrganizationId: string;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    
  //displayedColumns: string[] = ['organizationName', 'description', 'city','province','country','postalCode','companyId', 'createdDateTime','status', 'actions'];
  displayedColumns: string[] = ['organizationName', 'city','province','country','postalCode','createdDateTime','SessionTimeout','status', 'actions'];
  constructor(
    errorLogger: ErrorReportingService,
    private organizationService: OrganizationService,
    private errorReportingService: ErrorReportingService, // Include if needed
    public datePipe: DatePipe,
    private dialog: MatDialog,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private userDataService:UserDataService
  ) {
    super(errorLogger,dialog);
  }

  ngOnInit(): void {

  
    //this.selectedOrganizationId = localStorage.getItem('selectedOrganizationId'); 
     this.selectedOrganizationId = this.userDataService.getSelectedOrganization().toString();
     // Fetch organizations based on the selectedOrganizationId
   // this.fetchOrganizations();
    const user = this.authService.getUserDetails();
    if (user) {
      this.role =user.userType ;
 
    }
    this.fetchOrganizationsBasedOnId();
  }
   ngAfterViewInit(): void {
  this.organization.paginator = this.paginator;
  this.organization.sort = this.sort;
  this.paginator.pageSize = 5;  // Set initial page size
}
  
 // Fetch organizations based on selectedOrganizationId
 /*fetchOrganizationsBasedOnId(): void {
  if ( this.role === 1) {
    // Call API to fetch all organizations
    this.fetchOrganizations();
  } else {
    if(!this.selectedOrganizationId)
    {
      this.fetchOrganizationsByID(this.selectedOrganizationId);
    }
    else
    
    {
      set a message for list
    }
    // Call API to fetch organization by ID
   
  }
}*/

fetchOrganizationsBasedOnId(): void {
  if (this.role === 1) {
    // Call API to fetch all organizations
    this.fetchOrganizations();
  } else {
    //console.log("save org id",this.selectedOrganizationId)
    if (this.selectedOrganizationId !== '0') {
      if (this.selectedOrganizationId) {
        // Call API to fetch organization by ID
    //    console.log("Fetching organization details for ID:", this.selectedOrganizationId);
        this.fetchOrganizationsByID(this.selectedOrganizationId);
      } else {
        // Set a message for the list
        this.message = "No organization assigned to you. Please contact the Super Admin.";
      }
    } else {
      // Handle case when organization ID is 0
      this.message = "No organization assigned to you. Please contact the Super Admin.";
    }
    
  }
}
 
  getStatus(status: number): string {
    switch (status) {
      case 2:
        return 'Trial';
      case 1:
        return 'Active';
      case 0:
        return 'In-Active';
      default:
        // Return 'Active' as the default status if the input is unrecognized
        return 'Active'; 
    }
  }

  OpenEntryDialog(): void {
    const dialogConfig = new MatDialogConfig();
    
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px'; // Adjust the width as needed
    dialogConfig.maxWidth = '90vw'; // Responsive max width
  
    dialogConfig.data = { title: 'Create Organization' }; // Pass the title in the data object
    //console.log( "  dialogConfig.data =", dialogConfig.data )
    const dialogRef = this.matDialog.open(CreateOrganizationDialogComponent, dialogConfig);
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status === true) {
          // Show success message
          this.snackBar.open(result.message, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
          this.fetchOrganizations(); // Refresh user list
        } else if (result.status === false) {
          // Show specific error message if provided
          const errorMessage = result.message || 'Error creating organozation. Please try again.'; // Use the provided message or a default one
          this.snackBar.open(errorMessage, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
        }
      }
    });
    
    
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.name) {
        // Handle the result here
      }
    });
  }
  OpenEditDialog(orgnizationId: string): void {

    //console.log("orgnizationId==",orgnizationId);
    
    const isEditMode = !!orgnizationId; // Determine if in edit mode based on orgnizationId
    const title = isEditMode ? 'Edit Organization' : 'Create Organization'; // Set the title based on the mode
    this.organizationService.getOrganizationById(orgnizationId).subscribe(
      (organization) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '600px'; // Adjust the width as needed
        dialogConfig.maxWidth = '90vw'; // Responsive max width
        
  
        
        dialogConfig.data = { 
          title, 
          organization
        };
      // console.log( dialogConfig.data);
        const dialogRef = this.matDialog.open(CreateOrganizationDialogComponent, dialogConfig);
  
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result.status === true) {
              // Show success message
              this.snackBar.open(result.message, 'Close', {
                duration: 3000, // Duration in milliseconds
              });
              this.fetchOrganizations(); // Refresh user list
            } else if (result.status === false) {
              // Show specific error message if provided
              const errorMessage = result.message || 'Error updating orgnization. Please try again.'; // Use the provided message or a default one
              this.snackBar.open(errorMessage, 'Close', {
                duration: 3000, // Duration in milliseconds
              });
            }
          } 
        });
      },
      (error) => {
        console.error('Error fetching orgnization by ID:', error);
        this.snackBar.open('Error fetching orgnization details. Please try again later.', 'Close', {
          duration: 3000, // Duration in milliseconds
        });
      }
    );
  }
  
  OpenUserDialog(orgnizationId: string,orgnizationName: string,): void {
    const dialogConfig = new MatDialogConfig();
    
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px'; // Adjust the width as needed
    dialogConfig.maxWidth = '90vw'; // Responsive max width
  //console.log("list org id",orgnizationId);
    //dialogConfig.data = { title: 'Manage Users' }; // Pass the title in the data object
    dialogConfig.data = { 
      title: 'Manage Users', 
      orgnizationId,
      orgnizationName
    };
    //console.log( "  dialogConfig.data =", dialogConfig.data )
    const dialogRef = this.matDialog.open(OrganizationsUsersComponent, dialogConfig);
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status === true) {
          // Show success message
          this.snackBar.open(result.message, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
          this.fetchOrganizations(); // Refresh user list
        } else if (result.status === false) {
          // Show specific error message if provided
          const errorMessage = result.message || 'Error creating organozation. Please try again.'; // Use the provided message or a default one
          this.snackBar.open(errorMessage, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
        }
      }
    });
    
    
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.name) {
        // Handle the result here
      }
    });
  }
 
  OpenSeessionTimeoutDialog(orgnizationId: string,orgnizationName: string,): void {
    const dialogConfig = new MatDialogConfig();
    
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px'; // Adjust the width as needed
    dialogConfig.maxWidth = '90vw'; // Responsive max width
  //console.log("list org id",orgnizationId);
    //dialogConfig.data = { title: 'Manage Users' }; // Pass the title in the data object
    dialogConfig.data = { 
      title: 'Manage Users', 
      orgnizationId,
      orgnizationName
    };
    //console.log( "  dialogConfig.data =", dialogConfig.data )
    const dialogRef = this.matDialog.open(OrganizationsSessiontimeoutComponent, dialogConfig);
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status === true) {
          // Show success message
          this.snackBar.open(result.message, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
          this.fetchOrganizations(); // Refresh user list
        } else if (result.status === false) {
          // Show specific error message if provided
          const errorMessage = result.message || 'Error creating organozation. Please try again.'; // Use the provided message or a default one
          this.snackBar.open(errorMessage, 'Close', {
            duration: 3000, // Duration in milliseconds
          });
        }
      }
    });
    
    
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.name) {
        // Handle the result here
      }
    });
  }
 // Assuming getOrganizations() returns a list of Organization[]
fetchOrganizations(): void {
  this.organizationService.getOrganizations().subscribe(
    (data: Organization[]) => {
      this.organization.data = data;  // Assign fetched data to MatTableDataSource

     
    },
    
    (error) => {
      console.error('Error fetching organizations', error);
      this.hasError = true;  // Set hasError if there's an error
    }
  );
}

// Assuming getOrganizationById() returns a single Organization, not an array
fetchOrganizationsByID(organizationId: string): void {
  this.organizationService.getOrganizationById(organizationId).subscribe(
    (data: Organization) => {  // Expecting a single Organization object
      this.organization.data = [data];  // Wrap in an array to assign to MatTableDataSource

      
    },
    (error) => {
      console.error('Error fetching organization by ID', error);
      this.hasError = true;  // Set hasError if there's an error
    }
  );
}



/*updateOrganizationState(organizationId: string): void {
  // Replace the confirm with a custom confirmation dialog
  const storedUserData=this.userDataService.getOrgData();
  this.showConfirmDialog(
    'Delete Organization?', // Title of the dialog
    'Are you sure you want to delete this organization?', // Message of the dialog
    async (result) => {
      if (result) { // Proceed only if the user confirms (result is true)
        // Show busy dialog before starting the deletion process
        const busyDialog = this.showBusyDialog('Deleting organization...');
        // Create the payload for the POST request
        const payload = {
          id: organizationId,
          status: '0', // Assuming 'inactive' marks the organization as deleted
          userId:storedUserData.userId
        };
      
        try {
          // Call the service to update the organization status via a POST request
          const response = await this.organizationService.changeOrganizationStatus(payload);

          // Handle success, refresh the table or notify the user
          //console.log('Organization status updated successfully');
          busyDialog.close();
          // Show success message from the response
          this.snackBar.open('Organization deleted successfully', 'Close', {
            duration: 3000, // Duration for the snackbar
          });

          this.fetchOrganizations(); // Refresh the organization list
        } catch (error) {
          // Handle error (e.g., show an error message)
          console.error('Failed to delete organization status:', error);

          // Show the error message from the response or a default one
          const errorMessage = error?.error?.message || 'Failed to delete organization. Please try again.';
          this.snackBar.open(errorMessage, 'Close', {
            duration: 3000, // Duration for the snackbar
          });
        }
      }
    }
  );
}*/


updateOrganizationState(organizationId: string, orgnizationName: string): void {
  const storedUserData = this.userDataService.getOrgData();

  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '600px';
  dialogConfig.maxWidth = '90vw';
  dialogConfig.data = {
    title: 'Deactivate Organization',
    organizationId,
    orgName:orgnizationName,
    userId: storedUserData.userId
  };

  // Open busy dialog before launching deactivation
  
  const dialogRef = this.matDialog.open(DeactivateOrganizationDialogComponent, dialogConfig);

  dialogRef.afterClosed().subscribe(result => {
    // Always close the busy dialog, regardless of result
  
    if (result) {
      this.snackBar.open(result.message, 'Close', { duration: 3000 });

      if (result.status === true) {
        this.fetchOrganizations();
      }
    }
  });
}

 applyFilter(event: Event): void {
  const filterValue = (event.target as HTMLInputElement).value;
  this.organization.filter = filterValue.trim().toLowerCase();
  if (this.organization.paginator) {
    this.organization.paginator.firstPage();
  }
}


}
